import envs from './envs.json';

const env = process.env.REACT_APP_ENV || 'local';
const version = process.env.REACT_APP_VERSION;

console.log(`Monax: ${env} build - version ${version}`); // eslint-disable-line no-console

export const config = { ...envs[env], env, version };
export default config;
